import { render, staticRenderFns } from "./BuyOrderPassCode.vue?vue&type=template&id=0d0198f2&"
import script from "./BuyOrderPassCode.vue?vue&type=script&lang=js&"
export * from "./BuyOrderPassCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports